import React, { useState, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tabs, Form, Input, Button } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import { updateSalerConfig } from '../../store/reducers/salerConfig';
import { RouterContext } from '../../context';
import token from '../../utils/token';
import accountInfo from '../../utils/accountInfo';
import { getSystemTokenByAccount, getUserInfo, getWxAppId } from '../../apis/system';
import { getSalerConfig } from '../../apis/saler';

import styles from './index.module.less';
import imgLogo from '../../assets/images/login__logo.png';

interface FormModel {
    account: string;
}

// 用于开发测试登录
export default function LoginInner() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { regenerate, onUpdate, defaultRoute } = useContext(RouterContext);
    const [form] = Form.useForm<FormModel>();
    const [jump, setJump] = useState(false);

    function logined(_token: string) {
        token.set(_token);
        Promise.all([getUserInfo(), getWxAppId(), getSalerConfig()]).then(([userInfo, appId, salerConfig]) => {
            accountInfo.update({
                name: userInfo.data.name,
                avatar: '',
                enterpriseName: userInfo.data.corporationName,
                userId: userInfo.data.userId,
                wxAppId: appId.data,
                systemVersion: userInfo.data.systemVersion,
            });
            dispatch(updateSalerConfig(salerConfig.data));
            onUpdate(() => setJump(true));
            regenerate();
        });
    }

    function handleLogin() {
        form.validateFields().then((model) => {
            getSystemTokenByAccount(model.account).then((res) => {
                logined(res.data);
            });
        });
    }

    const LoginAccount = (
        <>
            <Form form={form}>
                <Form.Item name="account" rules={[{ required: true, message: '账号不能为空' }]}>
                    <Input
                        size="large"
                        allowClear={true}
                        placeholder="请输入账号"
                        prefix={<UserOutlined className={styles['form-icon']} />}
                        onKeyUp={(e) => ['Enter', 'NumpadEnter'].includes(e.code) && handleLogin()}
                    />
                </Form.Item>
            </Form>
            <Button type="primary" onClick={handleLogin} className={styles['login-btn']}>
                登录
            </Button>
        </>
    );

    useEffect(() => {
        if (jump) {
            const from = location.state?.from || { pathname: '', search: '' };
            const redirect =
                `${from?.pathname}${from?.search}` ||
                `${defaultRoute.path}${defaultRoute.query ? `?${defaultRoute.query}` : ''}`;
            navigate(redirect, { replace: true });
        }
    }, [jump, location, navigate, defaultRoute]);

    return (
        <div className={`flex ${styles.login}`}>
            <div className={`flex ${styles.main}`}>
                <div className={styles.banner}></div>
                <div className={styles.panel}>
                    <div className={`flex ${styles.header}`}>
                        <img src={imgLogo} alt="" className={styles.logo} />
                        <span className={styles.title}>{process.env.REACT_APP_NAME}</span>
                    </div>
                    <Tabs
                        defaultActiveKey="account"
                        centered={true}
                        items={[
                            {
                                label: '账号登录',
                                key: 'account',
                                children: LoginAccount,
                            },
                        ]}
                    />
                </div>
            </div>
        </div>
    );
}
